<h1 mat-dialog-title>{{ 'common.reportType.title' | translate }}</h1>
<form>

  <mat-accordion>
    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'common.reportType.options.reportType' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (!data.isForAutomaticSign) {
        <mat-radio-group class="vertical-radio-group" [ngModel]="optionSelected" [ngModelOptions]="{standalone: true}"
          >
          @for (item of optionsToDownload; track item) {
            <mat-radio-button class="vertical-radio-button" [value]="item"
              (change)="onOptionChange($event)">
              {{ 'common.reportType.' + item | translate }}
            </mat-radio-button>
          }
        </mat-radio-group>
      }

    </mat-expansion-panel>

    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'common.reportType.options.language.label' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (showChangeLangIcon() && !data.isForAutomaticSign) {
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'common.reportType.options.language.label' | translate }}</mat-label>
          <mat-select [(ngModel)]="reportConfig.lang" [ngModelOptions]="{standalone: true}">
            @for (item of langs; track item) {
              <mat-option [value]="item.lang">
                <mat-icon svgIcon="{{item.flag}}"></mat-icon>
                {{item.fullLang}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

    </mat-expansion-panel>

    @if (showConfigReport()) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'common.reportType.options.conclusions' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-checkbox name="changeConclusions" [ngModel]="changeConclusions" (change)="onChangeConclusionsCheck($event)">
          {{'common.reportType.options.conclusions.label' | translate }}
        </mat-checkbox>
        @if (changeConclusions) {
          <button mat-icon-button (click)="reloadConclusions()" matTooltip="{{ 'button.reload' | translate }}"
            >
            <mat-icon>refresh</mat-icon>
          </button>
        }
        @if (changeConclusions) {
          <div>
            <br />
            <textarea matInput name="conclusions" style="resize: none;" [(ngModel)]="reportConfig.conclusions"
              placeholder="{{ 'common.reportType.options.conclusions.field' | translate }}" rows="10"
            matAutosizeMinRows="10" style="resize: none;" required> </textarea>
          </div>
        }
      </mat-expansion-panel>
    }
  </mat-accordion>

  <br /><br />

  <div mat-dialog-actions class="qualificates-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick(false)" [disabled]="optionSelected == null"
    cdkFocusInitial>{{ 'button.download' | translate }}</button>
    <button mat-raised-button color="primary" (click)="onOkClick(true)"
    cdkFocusInitial>{{ 'button.download.hybride' | translate }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>